export default __webpack_public_path__ + "static/insect-based-dog-food-4-fd79f48c6c9fd61fdff5417d90f78bab.jpg";